import { camelCase } from 'lodash-es';
import mapKeysDeep from './map-keys-deep';

export default function mapKeysToCamelCase(obj, recursive = false) {
  return mapKeysDeep(obj, (v, k) => camelCase(k), recursive);
}
